module.exports = __webpack_public_path__ + "static/img/see-achievement-icon.8aab9e95.png";